import { useContext } from 'react';
import { getLocalizedShopSettings } from '../../../Utils/locale';
import useLocale from '../../../Hooks/use-locale';
import useLocalize from '../../../Hooks/useLocalize';
import GiftcardFAQ from '../../../ui-components/giftcard-faq';
import { giftcardState } from '../client-state/giftcard-state-context';
import useGiftcardShop from '../server-data/use-giftcard-shop';

const GiftcardFAQWithData = () => {
  const { data: shop } = useGiftcardShop();
  const { state } = useContext(giftcardState);
  const { languageAsEnum } = useLocale();
  const localize = useLocalize();

  const heading =
    shop?.giftCardLocalizations?.heading?.[languageAsEnum] ||
    (shop?.shopSettings?.giftcard?.introText
      ? getLocalizedShopSettings(shop?.shopSettings.giftcard.introText, languageAsEnum)
      : localize('faq.title'));

  const instructions =
    shop?.giftCardLocalizations?.instructions?.[languageAsEnum] ?? undefined;

  const faq = shop?.shopSettings?.giftcard?.faq ?? false;

  const questions = shop?.shopSettings?.giftcard?.questions
    ? getLocalizedShopSettings(shop?.shopSettings.giftcard.questions, languageAsEnum)
    : [];

  return (
    <GiftcardFAQ
      heading={heading}
      instructions={instructions}
      faq={faq}
      questions={questions}
      vouchers={state.vouchers}
      giftcardValidity={shop?.shopSettings?.giftcard?.validity ?? undefined}
    />
  );
};

export default GiftcardFAQWithData;
